/* Standard product page - the clip-art page's behaviour without the personaliser.
 *
 * What it owns: the photo gallery, the variant chips, the price band (was / Save %), the
 * countdown, the delivery promise and its country, quantity, shipping protection and the cart.
 * What it does not have: a payload, a canvas, a live preview. Its only line-item properties come
 * from the name card a product switches on with `custom.plain_fields`.
 *
 * The cart flow is the clip-art page's, and for the same reason: Minimog's own handler is bound
 * to this very form and cannot be stopped from outside, so the theme is left to add the line,
 * the cart is polled until it grows, and only then are the name's fee and protection added and
 * the shopper moved on.
 */
(function () {
  'use strict';

  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  // Is a cart drawer on screen - Kaching Cart's <kaching-cart-drawer>, or the theme's own?
  // A closed one is display:none, hidden, or parked off the right edge.
  function drawerOpen() {
    var els = document.querySelectorAll('kaching-cart-drawer, .kaching-cart__inner, cart-drawer, ' +
      '.m-cart-drawer, [id*="cart-drawer" i], [class*="cart-drawer" i]');
    return Array.prototype.some.call(els, function (e) {
      var st = getComputedStyle(e), r = e.getBoundingClientRect();
      return st.display !== 'none' && st.visibility !== 'hidden' && st.opacity !== '0' &&
        r.width > 200 && r.height > 300 && r.left < window.innerWidth - 50 && r.right > 50;
    });
  }
  function waitForDrawer(ms) {
    var end = Date.now() + ms;
    return (function look() {
      if (drawerOpen()) return Promise.resolve(true);
      if (Date.now() > end) return Promise.resolve(false);
      return sleep(150).then(look);
    })();
  }

  function money(cents, format) {
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    // Minimog's Shopify.formatMoney throws without a format string, so the format is passed in
    return format ? format.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/<[^>]*>/g, '') : '$' + amount;
  }

  function start(root) {
    var form = root.querySelector('[data-ca-form]');
    if (!form) return;
    var moneyFormat = root.getAttribute('data-pdp-money') || '';
    var protectVariant = (root.getAttribute('data-pdp-protect-variant') || '').trim();
    var protectCents = parseInt(root.getAttribute('data-pdp-protect-cents'), 10) || 0;
    var qtyInput = root.querySelector('[data-pdp-qty-input]');
    var qtyValue = root.querySelector('[data-pdp-qty-value]');
    var totalEl = root.querySelector('[data-pdp-total]');
    var protectRow = root.querySelector('[data-pdp-protect]');
    var protectBox = root.querySelector('[data-pdp-protect-input]');
    var idInput = root.querySelector('[data-ca-id]');
    var priceEl = root.querySelector('[data-ca-price]');
    var wasEl = root.querySelector('[data-pdp-was]');
    var saveEl = root.querySelector('[data-pdp-save]');
    var cta = root.querySelector('[data-ca-cta]');
    var buy = root.querySelector('[data-pdp-buy]');
    var qty = 1, busy = false;

    var prod = null;
    try { prod = JSON.parse(root.querySelector('[data-ca-product]').textContent); } catch (e) { /* page stays as rendered */ }

    /* ---- countdown to the end of today ---- */
    var clock = root.querySelector('[data-pdp-countdown]');
    if (clock) {
      var tick = function () {
        var now = new Date(), end = new Date(now);
        end.setHours(24, 0, 0, 0);
        var left = Math.max(0, Math.floor((end - now) / 1000));
        clock.textContent = Math.floor(left / 3600) + 'h ' + Math.floor((left % 3600) / 60) + 'm ' + (left % 60) + 's';
      };
      tick();
      setInterval(tick, 1000);
    }

    /* ---- delivery dates: home and everywhere else, the shop's two promises ---- */
    var fmt = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    var days = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return d; };
    var num = function (name, fallback) { return parseInt(root.getAttribute(name), 10) || fallback; };
    var home = { ship: num('data-pdp-ship-days', 4), min: num('data-pdp-deliver-days', 12),
                 max: num('data-pdp-deliver-max', 0) };
    var abroad = { ship: num('data-pdp-intl-ship-days', home.ship),
                   min: num('data-pdp-intl-deliver-days', home.min),
                   max: num('data-pdp-intl-deliver-max', home.max) };
    var country = root.querySelector('[data-pdp-country]');
    var REMEMBER = 'pdpDeliverTo';

    function showDates() {
      var to = country && country.value !== 'home' ? abroad : home;
      var dates = { '0': days(0), ship: days(to.ship), deliver: days(to.min) };
      var deliverText = to.max > to.min ? fmt(dates.deliver) + ' - ' + fmt(days(to.max)) : fmt(dates.deliver);
      Array.prototype.forEach.call(root.querySelectorAll('[data-pdp-date]'), function (el) {
        var key = el.getAttribute('data-pdp-date');
        if (key === 'deliver') { el.textContent = deliverText; return; }
        var d = dates[key];
        if (d) el.textContent = fmt(d);
      });
      var eta = root.querySelector('[data-pdp-eta]');
      if (eta) eta.textContent = deliverText;
    }

    if (country) {
      try {
        var kept = localStorage.getItem(REMEMBER);
        if (kept) {
          var match = Array.prototype.filter.call(country.options, function (o) { return o.value === kept; })[0];
          if (match) country.value = kept;
        }
      } catch (e) { /* a browser that refuses storage still gets the home promise */ }
      country.addEventListener('change', function () {
        try { localStorage.setItem(REMEMBER, country.value); } catch (e) { }
        showDates();
      });
    }
    showDates();

    /* ---- gallery ---- */
    var showSlide = null;
    (function gallery() {
      var slides = root.querySelectorAll('[data-pdp-slide]');
      var thumbs = root.querySelectorAll('[data-pdp-thumb]');
      var counter = root.querySelector('[data-pdp-slide-now]');
      if (!slides.length) return;
      var wanted = 0;
      function swap(i) {
        Array.prototype.forEach.call(slides, function (s) {
          s.hidden = s.getAttribute('data-pdp-slide') !== String(i);
        });
      }
      // The photos after the first load lazily. The old photo stays up until the new one has
      // arrived, so the frame never shows a blank moment - the thumbnail and the counter answer
      // at once, the picture follows when it is ready (and at once when it already is).
      function show(i) {
        wanted = i;
        Array.prototype.forEach.call(thumbs, function (t) {
          var on = t.getAttribute('data-pdp-thumb') === String(i) ? 'true' : 'false';
          if (t.getAttribute('aria-current') !== on) t.setAttribute('aria-current', on);
        });
        if (counter) counter.textContent = i + 1;
        var next = slides[i] && slides[i].querySelector('img');
        if (!next || (next.complete && next.naturalWidth > 0)) return swap(i);
        next.loading = 'eager';
        var done = function () { if (wanted === i) swap(i); };
        next.addEventListener('load', done, { once: true });
        next.addEventListener('error', done, { once: true });
        setTimeout(done, 2500);          // a stalled network still gets the picture it asked for
      }
      Array.prototype.forEach.call(thumbs, function (t) {
        t.addEventListener('click', function () { show(Number(t.getAttribute('data-pdp-thumb'))); });
      });
      show(0);
      showSlide = show;      // picking a colour moves the gallery to that colour's photo
    })();

    /* ---- variants: the chips pick one, everything else follows it ---- */
    var chosen = {};
    (function readChosen() {
      Array.prototype.forEach.call(root.querySelectorAll('[data-pdp-opt]'), function (row) {
        var on = row.querySelector('[aria-pressed="true"]') || row.querySelector('[data-pdp-value]');
        if (on) chosen[row.getAttribute('data-pdp-opt')] = on.getAttribute('data-pdp-value');
      });
    })();

    function variantFor(pick) {
      if (!prod || !prod.variants) return null;
      return prod.variants.filter(function (v) {
        return (!pick['1'] || v.option1 === pick['1']) &&
               (!pick['2'] || v.option2 === pick['2']) &&
               (!pick['3'] || v.option3 === pick['3']);
      })[0] || null;
    }

    // a value that no variant carries at all is dead and says so; one that is only unavailable
    // in the current combination is left alone, because picking it changes the combination
    function offered(index, value) {
      if (!prod || !prod.variants) return true;
      var key = 'option' + index;
      return prod.variants.some(function (v) { return v[key] === value; });
    }

    function paintChips() {
      Array.prototype.forEach.call(root.querySelectorAll('[data-pdp-opt]'), function (row) {
        var index = row.getAttribute('data-pdp-opt');
        Array.prototype.forEach.call(row.querySelectorAll('[data-pdp-value]'), function (b) {
          var value = b.getAttribute('data-pdp-value');
          b.setAttribute('aria-pressed', chosen[index] === value ? 'true' : 'false');
          b.disabled = !offered(index, value);
        });
      });
    }

    // the chosen value beside the option's name, the way a shopper reads "Color: Turquoise"
    function namePicked() {
      Array.prototype.forEach.call(root.querySelectorAll('[data-pdp-opt]'), function (row) {
        var out = row.querySelector('[data-pdp-opt-value]');
        if (out) out.textContent = chosen[row.getAttribute('data-pdp-opt')] || '';
      });
    }

    function applyVariant() {
      var v = variantFor(chosen);
      namePicked();
      if (!v) {
        if (cta) { cta.disabled = true; cta.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      // a variant with its own photo shows it: the shopper sees the colour they just picked
      if (showSlide && v.img) showSlide(Number(v.img) - 1);
      if (priceEl) priceEl.textContent = money(Number(v.price), moneyFormat);
      var was = Number(v.compareAt) || 0, now = Number(v.price);
      var on = was > now;
      if (wasEl) { wasEl.textContent = on ? money(was, moneyFormat) : ''; wasEl.hidden = !on; }
      if (saveEl) { saveEl.textContent = on ? 'Save ' + Math.round((was - now) * 100 / was) + '%' : ''; saveEl.hidden = !on; }
      if (cta) {
        cta.disabled = !v.available;
        cta.textContent = v.available ? (cta.getAttribute('data-label') || 'Add to cart') : 'Sold out';
      }
      refresh();
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-pdp-value]'), function (b) {
      b.addEventListener('click', function () {
        var row = b.closest('[data-pdp-opt]');
        if (!row) return;
        chosen[row.getAttribute('data-pdp-opt')] = b.getAttribute('data-pdp-value');
        paintChips();
        applyVariant();
      });
    });

    /* ---- quantity, protection, the sticky total ---- */
    function variantCents() {
      var v = variantFor(chosen);
      if (v) return Number(v.price);
      var digits = (priceEl ? priceEl.textContent : '').replace(/[^\d]/g, '');
      return digits ? parseInt(digits, 10) : parseInt(root.getAttribute('data-pdp-price-cents'), 10) || 0;
    }

    function refresh() {
      if (qtyValue) qtyValue.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
      if (totalEl) {
        var cents = variantCents() * qty + (protectBox && protectBox.checked ? protectCents : 0) +
          (personalised() ? feeCents * qty : 0);
        totalEl.textContent = money(cents, moneyFormat);
      }
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-pdp-qty]'), function (b) {
      b.addEventListener('click', function () {
        qty = Math.max(1, Math.min(10, qty + (parseInt(b.getAttribute('data-pdp-qty'), 10) || 0)));
        refresh();
      });
    });
    if (protectBox) {
      protectBox.addEventListener('change', function () {
        if (protectRow) protectRow.classList.toggle('on', protectBox.checked);
        refresh();
      });
    }

    /* ---- the name card (custom.plain_fields): switched on from the start, the shopper types ---- */
    var pers = root.querySelector('[data-pdp-pers]');
    var persToggle = pers ? pers.querySelector('[data-pdp-pers-toggle]') : null;
    var persFields = pers ? pers.querySelector('[data-pdp-pers-fields]') : null;
    var persNote = pers ? pers.querySelector('[data-pdp-pers-note]') : null;
    var persHint = pers ? pers.querySelector('[data-pdp-pers-hint]') : null;
    var persErr = pers ? pers.querySelector('[data-pdp-pers-err]') : null;
    var persInputs = pers ? Array.prototype.slice.call(pers.querySelectorAll('[data-pdp-field-input]')) : [];
    var feeVariant = pers ? (pers.getAttribute('data-pdp-fee-variant') || '').trim() : '';
    var feeCents = pers ? parseInt(pers.getAttribute('data-pdp-fee-cents'), 10) || 0 : 0;
    var carriers = [];

    function persOn() { return !!persToggle && persToggle.checked; }
    function typed(inp) { return inp.value.trim(); }
    // what costs the fee: the card on and something actually typed - an empty card prints nothing
    function personalised() { return persOn() && persInputs.some(typed); }

    function paintPers() {
      if (!pers) return;
      var on = persOn();
      if (persFields) persFields.hidden = !on;
      if (persNote) persNote.textContent = persNote.getAttribute(on ? 'data-on' : 'data-off');
      if (persHint) {
        persHint.hidden = !on;
        persHint.textContent = persHint.getAttribute(personalised() ? 'data-typed' : 'data-empty');
      }
      if (!on && persErr) persErr.hidden = true;
      persInputs.forEach(function (inp) {
        var row = inp.closest('[data-pdp-pers-field]');
        if (row && (!on || typed(inp))) row.classList.remove('is-missing');
      });
      refresh();
    }
    if (persToggle) persToggle.addEventListener('change', paintPers);
    persInputs.forEach(function (inp) {
      inp.addEventListener('input', function () {
        if (persErr && typed(inp)) persErr.hidden = true;
        paintPers();
      });
      inp.addEventListener('blur', function () { if (inp.value !== typed(inp)) { inp.value = typed(inp); paintPers(); } });
    });

    // What the shopper typed goes into the form as properties[...], with a hidden key the fee line
    // carries too, so the two lines read as one order item. False, with the field in view, when a
    // required one is empty. Switched off or left empty, the item goes in plain.
    var persLink = '';
    function persWrite() {
      carriers.forEach(function (c) { if (c.parentNode) c.parentNode.removeChild(c); });
      carriers = [];
      persLink = '';
      if (!persOn()) return true;
      var missing = persInputs.filter(function (inp) { return inp.hasAttribute('data-pdp-required') && !typed(inp); });
      if (missing.length) {
        missing.forEach(function (inp) { inp.closest('[data-pdp-pers-field]').classList.add('is-missing'); });
        if (persErr) persErr.hidden = false;
        missing[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
        missing[0].focus({ preventScroll: true });
        return false;
      }
      if (!personalised()) return true;
      persLink = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      var put = function (name, value) {
        var c = document.createElement('input');
        c.type = 'hidden'; c.name = 'properties[' + name + ']'; c.value = value;
        form.appendChild(c);
        carriers.push(c);
      };
      persInputs.forEach(function (inp) { if (typed(inp)) put(inp.getAttribute('data-pdp-prop'), typed(inp)); });
      if (feeVariant) put('_pers', persLink);
      return true;
    }

    paintChips();
    applyVariant();
    paintPers();

    /* ---- add to cart / buy now ---- */
    function place(where) {
      if (busy) return;
      if (!persWrite()) return;
      var fee = personalised() && feeVariant ? { id: Number(feeVariant), quantity: qty, properties: { _pers: persLink } } : null;
      busy = true;
      var count = function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { return c.item_count; });
      };
      count().then(function (before) {
        // the theme's handler adds the line when the form submits; ours only waits for it
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        var deadline = Date.now() + 8000;
        return (function again() {
          return sleep(400).then(count).then(function (now) {
            if (now > before) return now;
            if (Date.now() > deadline) throw new Error('the cart did not take this item');
            return again();
          });
        })();
      }).then(function () {
        // the name's fee (one per item) and protection follow the item in one request
        var extra = [];
        if (fee) extra.push(fee);
        if (protectBox && protectBox.checked && protectVariant) extra.push({ id: Number(protectVariant), quantity: 1 });
        if (!extra.length) return null;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: extra })
        }).then(function (r) {
          if (!r.ok && fee) throw new Error('The name could not be added - please try again.');
          return r;
        });
      }).then(function () {
        if (where === 'buy') { window.location.href = '/checkout'; return null; }
        // Add to cart stays on the page, as on every other product in the store: the cart drawer
        // the store runs (Kaching Cart, 2026-09) opens by itself once the line is in. Going to
        // /cart as well showed the drawer and then left the page from under it (2026-09-25).
        // Only when no drawer shows up is /cart still the way to see the cart.
        return waitForDrawer(2500).then(function (open) {
          busy = false;
          if (!open) window.location.href = '/cart';
        });
      }).catch(function (e) {
        busy = false;
        var err = root.querySelector('[data-ca-err]');
        if (err) { err.textContent = String((e && e.message) || e); err.hidden = false; }
      });
    }

    // capture, so the theme's own click handler never runs twice
    function claim(el, where) {
      if (!el) return;
      el.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        place(where);
      }, true);
    }
    claim(cta, 'cart');
    claim(buy, 'buy');
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pdp-plain]'), start);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
